import _ from "lodash";
import React from "react";
import classes from "./TermWiseHistoryList.scss";
import Accordian from "UIComponents/Accordian";
import { fontStyle } from "Constants";
import { useI18n } from "Hooks";
import RightPaneHistoryList from "ClassProgressSummaryV2/components/RatingHistory/MiddleBody/HistoryList";
import AddObservationPopoverHistoryList from "../HistoryList";
import { getCurrentTerm } from "Utils";

const styles = {
  headerStyle: { padding: "0px" },
  mainContentContainerStyle: { marginBottom: "0px" },
};

const AccordianComponent = ({
  title,
  hideContainerBorder,
  getExpandedContent,
  showLabelBorder,
  isExpanded,
}) => {
  return (
    <Accordian
      title={title}
      getExpandedContent={getExpandedContent}
      hideContainerBorder={hideContainerBorder}
      showLabelBorder={showLabelBorder}
      headerStyle={styles.headerStyle}
      customTitleStyle={fontStyle.demiBold}
      mainContentContainerStyle={styles.mainContentContainerStyle}
      isExpanded={isExpanded}
    />
  );
};

const TermWiseHistoryList = ({
  ratingHistory,
  terms,
  isPopUp,
  canRemoveRating,
  showThumbnail,
  onClickHistoryItem,
  deleteRatingHistory,
  userType,
  showBasicHistoryList,
  type,
  isAdminGradebook,
  isGradingPeriodUnlocked = true,
  canManageGradebook,
}) => {
  const { t } = useI18n(["configuration"]);
  const academicTermToRatingMapping = _.groupBy(ratingHistory, rating => {
    return _.get(rating, "academicTerm.id", "others");
  });

  const academicTermToRatingMappingKeys = _.keys(academicTermToRatingMapping);

  const filteredAcademicTermToRatingMapping = _.filter(terms, ({ id }) =>
    _.includes(academicTermToRatingMappingKeys, id)
  );

  const orderedAcademicTermToRatingMapping = _.orderBy(
    filteredAcademicTermToRatingMapping,
    ["endDate", "startDate"],
    ["desc", "asc"]
  );

  if (_.includes(academicTermToRatingMappingKeys, "others")) {
    orderedAcademicTermToRatingMapping.push({ id: "others" });
  }

  const getHistoryList = ({ id }) => {
    switch (type) {
      case "sidePaneHistoryList":
        return (
          <RightPaneHistoryList
            isPopUp={isPopUp}
            ratingHistory={academicTermToRatingMapping[id]}
            canRemoveRating={canRemoveRating}
            showThumbnail={showThumbnail}
            onClickHistoryItem={onClickHistoryItem}
            deleteRatingHistory={deleteRatingHistory}
            showBasicHistoryList={showBasicHistoryList}
            userType={userType}
            isAdminGradebook={isAdminGradebook}
            isGradingPeriodUnlocked={isGradingPeriodUnlocked}
            canManageGradebook={canManageGradebook}
          />
        );
      case "addObservationPopoverHistoryList":
        return (
          <AddObservationPopoverHistoryList
            isPopUp={isPopUp}
            ratingHistory={academicTermToRatingMapping[id]}
            canRemoveRating={canRemoveRating}
            showThumbnail={showThumbnail}
            onClickHistoryItem={onClickHistoryItem}
            deleteRatingHistory={deleteRatingHistory}
            showBasicHistoryList={showBasicHistoryList}
            userType={userType}
          />
        );
    }
  };

  const currentTerm = getCurrentTerm({
    terms: orderedAcademicTermToRatingMapping,
  });

  const currentTermId = _.get(currentTerm, "id");

  return _.map(orderedAcademicTermToRatingMapping, ({ id }) => {
    const title =
      id != "others"
        ? _.get(academicTermToRatingMapping[id], "[0].academicTerm.label", "")
        : t("configuration:others");
    return (
      <div className={classes.accordianContainer} key={id}>
        <AccordianComponent
          title={title}
          getExpandedContent={() => getHistoryList({ id })}
          hideContainerBorder={true}
          showLabelBorder={false}
          isExpanded={id === currentTermId}
        />
      </div>
    );
  });
};

export default TermWiseHistoryList;
